<div class="wrap">
    <div class="form-container">
        <ejs-dropdownlist [dataSource]="matterDropdownData"
                          [fields]="{ text: 'displayText', value: 'matterId' }"
                          [placeholder]="'Select Matter'"
                          [allowFiltering]="true"
                          [filterType]="'Contains'"
                          (filtering)="onMatterFiltering($event)"
                          (change)="onMatterChange($event)">
        </ejs-dropdownlist>
    </div>

    <div class="grid-container">
        <div *ngIf="isGridLoading" class="spinner">
            <mat-progress-spinner color="accent" mode="indeterminate" [diameter]="40"></mat-progress-spinner>
        </div>
        <ejs-grid #grid
                  [dataSource]="disbursements"
                  [allowPaging]="true"
                  [pageSettings]="pageSettings"
                  [allowFiltering]="true"
                  [filterSettings]="filterSettings"
                  [allowSorting]="true"
                  [allowResizing]="true"
                  [selectionSettings]="{ type: 'Menu' }"
                  [showColumnMenu]="false"
                  [enableHover]="false"
                  [rowHeight]="36"
                  height="100%"
                  class="sync-grid"
                  (created)="onGridCreated()">

            <e-columns>
                <e-column field="description" headerText="Description" width="200" textAlign="Left" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="quantity" headerText="Quantity" width="90" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="unitPrice" headerText="Unit Price" width="95" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="vatCode" headerText="Vat Code" width="95" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="subTotal" typeof="number" headerText="SubTotal" width="90" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="tax" headerText="VAT" width="65" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="incomeAccount" headerText="Income Account" width="200" textAlign="Left" [visible]="canViewIncomeAccount" clipMode="EllipsisWithTooltip">
                    <ng-template #template let-data>
                        {{ data.incomeAccount ?? '-' }}
                    </ng-template>
                </e-column>
                <e-column field="total" headerText="Total" width="70" textAlign="Right" clipMode="EllipsisWithTooltip"></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>
